import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { RouteConfig } from 'vue-router'

const SaleParams: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/SaleParamsView.vue')
const SaleTerms: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/SaleTermsView.vue')
const GrantsList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/GrantsListView.vue')
const PdfModelList: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/PdfModelListView.vue')
const PdfModelForm: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/PdfModelFormView/PdfModelFormView.vue')
const AccountListView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/AccountsView.vue')
const RecoveryInvoiceParamsView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/RecoveryInvoiceParamsView.vue')
const CustomerSepaParamsView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CustomerSepaParamsView.vue')
const StripeConfigView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/StripeConfigView.vue')
const SignConfigView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/SignConfigView.vue')
const ContractModelsListView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/ContractModelsListView.vue')
const ContractModelFormView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/ContractModelFormView/ContractModelFormView.vue')
const FecFileView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/FecFileView.vue')
const FecDownloadView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/FecDownloadView.vue')
const AccountingClosingView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/AccountingClosingView.vue')
const CommissionView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CommissionView.vue')
const CarParamsView: DynamicImport = () => import(/* webpackChunkName: "sales" */ '../views/CarParamsView.vue')

const configRoutes: (i18n: VueI18n) => RouteConfig[] = i18n => ([
  {
    name: 'sales-params',
    path: 'sales/params',
    component: SaleParams,
    meta: {
      title: i18n.t('sales.params.pageTitle')
    }
  },
  {
    name: 'sales-terms',
    path: 'sales/sale-terms',
    component: SaleTerms,
    meta: {
      title: i18n.t('sales.saleTerm.pageTitle')
    }
  },
  {
    name: 'sales-grants',
    path: 'sales/grants',
    component: GrantsList,
    meta: {
      title: i18n.t('sales.grant.pageTitle'),
      appModule: 'sales-grants'
    }
  },
  {
    name: 'sales-accounts',
    path: 'sales/accounts',
    component: AccountListView,
    meta: {
      title: i18n.t('sales.account.pageTitle'),
      pageHeader: false
    }
  },
  {
    name: 'pdf-models',
    path: 'pdf-models',
    component: PdfModelList,
    meta: {
      title: i18n.t('sales.pdfModel.pageTitle'),
      buttons: [
        {
          label: i18n.t('sales.pdfModel.addLabel'),
          click: (): void => {
            Vue.prototype.$kwSales.store.commit('app/updateHeaderAction', 'new-pdf-model')
          }
        }
      ]
    }
  },
  {
    name: 'sales-pdf-model-form',
    path: 'pdf-models/:id',
    component: PdfModelForm,
    meta: {
      title: i18n.t('sales.pdfModel.pageTitle')
    }
  },
  {
    path: 'sales/recovery-invoice-steps',
    name: 'sales-recovery-invoice-steps',
    component: RecoveryInvoiceParamsView,
    meta: {
      title: i18n.t('sales.recoveryInvoice.config.pageTitle'),
      appModule: 'sales-recovery'
    }
  },
  {
    path: 'sales/sepa',
    name: 'sepa-params',
    component: CustomerSepaParamsView,
    meta: {
      title: 'Mandats SEPA',
      appModule: 'sales-sepa'
    }
  },
  {
    path: 'sales/stripe',
    name: 'stripe-params',
    component: StripeConfigView,
    meta: {
      title: 'Paiement en ligne',
      appModule: 'stripe'
    }
  },
  {
    path: 'sales/contract-models',
    name: 'contract-models-list',
    component: ContractModelsListView,
    meta: {
      title: 'Contrats et abonnements',
      appModule: 'sales-contracts'
    }
  },
  {
    path: 'sales/contract-models/form/:id?',
    name: 'contract-models-form',
    component: ContractModelFormView,
    meta: {
      title: 'Modèle de contrat',
      pageHeader: false,
      appModule: 'sales-contracts'
    }
  },
  {
    path: 'accounting/fec',
    name: 'fec-file',
    component: FecFileView,
    meta: {
      title: 'Export des écritures comptable'
    }
  },
  {
    path: 'accounting/fec/download/:id',
    name: 'fec-download',
    component: FecDownloadView,
    meta: {
      pageHeader: false,
      title: 'Téléchargement'
    }
  },
  {
    path: 'accounting/accounting-closing',
    name: 'accounting-closing',
    component: AccountingClosingView,
    meta: {
      title: 'Clôture comptable'
    }
  },
  {
    path: 'sign-params',
    name: 'sign-params',
    component: SignConfigView,
    meta: {
      title: 'Signature électronique',
      appElectronicSign: true
    }
  },
  {
    path: 'commissions',
    name: 'commissions',
    component: CommissionView,
    meta: {
      title: 'Configuration des commissions',
      appModule: 'sales-commissions'
    }
  },
  {
    path: 'automotive',
    name: 'automotive',
    component: CarParamsView,
    meta: {
      title: 'Garage',
      appModule: 'automotive'
    }
  }
])

export default configRoutes
